module.exports = __webpack_public_path__ + "Assets/Images/qwilr-phone.png";